import { rootApi } from '../rootApi';

export const dealersStockViewApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getDealersStockByDealerId: builder.query({
            query: (params) => ({
                url: '/v1/dealersstockview/getdealersstockview',
                method: 'Get',
                params: {
                    ...(params.DealerId ? { DealerId: params.DealerId } : {}),
                    ...(params.DealerAddressId ? { DealerAddressId: params.DealerAddressId } : {}),
                    PageNumber: params.PageNumber ?? 1,
                    PageSize: params.PageSize ?? 10,
                    ...(params.LanguageId ? { LanguageId: params.LanguageId } : {}),
                    ...(params.PartCode ? { PartCode: params.PartCode } : {}),
                    ...(params.PartDesc ? { PartDesc: params.PartDesc } : {}),
                    ...(params.Block ? { Block: params.Block } : {}),
                    ...(params.Shelf ? { Shelf: params.Shelf } : {}),
                    ...(params.Sequence ? { Sequence: params.Sequence } : {}),
                    ...(params.Eyes ? { Eyes: params.Eyes } : {})
                }
            }),
            transformResponse: (response) => response?.data ?? response,
            serializeQueryArgs: ({ endpointName, queryArgs }) => {
                const { DealerId } = queryArgs || {};
                return `${endpointName}-${DealerId ?? 'none'}`;
            },
            merge: (currentCache, newItems) => Object.assign(currentCache, newItems),
            forceRefetch({ currentArg, previousArg }) {
                return JSON.stringify(currentArg) !== JSON.stringify(previousArg);
            },
            providesTags: (result, error, arg) => [{ type: 'DealersStockView', id: arg?.DealerId ?? 'LIST' }]
        }),
        getDealerPartHistory: builder.query({
            query: (params) => ({
                url: '/v1/dealersstockview/GetDealerPartHistory',
                method: 'GET',
                params: {
                    DealerId: params.DealerId,
                    DealerAddressId: params.DealerAddressId,
                    PartCode: params.PartCode,
                    PageNumber: params.PageNumber ?? 1,
                    PageSize: params.PageSize ?? 10
                }
            }),
            transformResponse: (response) => response?.data ?? response,
            serializeQueryArgs: ({ endpointName, queryArgs }) => {
                const k = queryArgs || {};
                return `${endpointName}-${k.DealerId || ''}-${k.DealerAddressId || ''}-${k.PartCode || ''}`;
            },
            merge: (currentCache, newItems) => Object.assign(currentCache || {}, newItems),
            forceRefetch({ currentArg, previousArg }) {
                return JSON.stringify(currentArg) !== JSON.stringify(previousArg);
            },
            providesTags: (result, error, arg) => [{ type: 'PartHistory', id: `${arg?.DealerId}-${arg?.DealerAddressId}-${arg?.PartCode}` }]
        }),
        exportDealersStockViewToExcel: builder.query({
            query: ({ LanguageId, CompressionType = 1, DealerId, DealerAddressId, partCode, partDesc, block, shelf, sequence, eyes } = {}) => {
                const params = { LanguageId, CompressionType };
                if (DealerId) params.DealerId = DealerId;
                if (DealerAddressId) params.DealerAddressId = DealerAddressId;
                if (partCode) params.partCode = partCode;
                if (partDesc) params.partDesc = partDesc;
                if (block) params.block = block;
                if (shelf) params.shelf = shelf;
                if (sequence) params.sequence = sequence;
                if (eyes) params.eyes = eyes;
                return {
                    url: '/v1/dealersstockview/exportdealersstockviewtoexcel',
                    method: 'GET',
                    params
                };
            },
            transformResponse: (response) => response?.data ?? response
        })
    })
});

export const {
    useGetDealersStockByDealerIdQuery,
    useGetDealerPartHistoryQuery,
    useLazyExportDealersStockViewToExcelQuery
} = dealersStockViewApi;
